import React from 'react'
import { Button, CloseButton, Dialog, HStack, Portal } from '@chakra-ui/react'
import type { DonationEvent } from '@kuow/core'
import { ReceiptBody } from './ReceiptBody'

export interface ReceiptModalProps {
  event: DonationEvent | null
  open: boolean
  memberName: string
  onOpenChange: (open: boolean) => void
}

export const ReceiptModal: React.FC<ReceiptModalProps> = ({ event, open, memberName, onOpenChange }) => {
  return (
    <Dialog.Root lazyMount open={open} onOpenChange={(d) => onOpenChange(d.open)}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner px={{ base: '4', md: '6' }} py={{ base: '4', md: '8' }}>
          <Dialog.Content w="full" maxW="md" mx="4" borderRadius="l3" overflow="hidden">
            <Dialog.Header px="6" pt="6" pb="2">
              <Dialog.Title>Payment Receipt</Dialog.Title>
            </Dialog.Header>
            <Dialog.Body px="6" pb="4">
              {event ? <ReceiptBody event={event} memberName={memberName} /> : null}
            </Dialog.Body>
            <Dialog.Footer px="6" pb="6">
              <HStack gap={3} justify="flex-end" w="full">
                <Button type="button" variant="outline" colorPalette="gray" onClick={() => onOpenChange(false)}>
                  Close
                </Button>
                {event ? (
                  <Button asChild colorPalette="river">
                    <a href={`/members/receipt/${event.id}`} target="_blank" rel="noopener noreferrer">
                      Print
                    </a>
                  </Button>
                ) : null}
              </HStack>
            </Dialog.Footer>
            <Dialog.CloseTrigger asChild>
              <CloseButton size="sm" />
            </Dialog.CloseTrigger>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
